export default {
  type: 'emails',
  name: 'Email List',
  permissions: {
    view: { app: 'people', role: 'people' },
    insert: { app: 'people', role: 'people' },
    update: { app: 'people', role: 'people' },
    delete: { app: 'people', role: 'people' }
  },
  search: {
    search: 'allEmailLists',
    orderBy: {
      type: 'EmailListsOrderBy',
      default: 'EMAIL_LIST_ASC'
    },
    fields: [
      {
        name: 'tsvSearch',
        label: 'Search',
        filterType: 'matches',
        searchOnly: true
      },
      {
        name: 'emailList',
        label: 'List',
        searchable: false,
        order: 'EMAIL_LIST'
      },
      {
        alias: 'owner',
        searchable: false,
        order: 'ROLE_NAME',
        join: 'roleByRoleName',
        fields: [
          'roleName',
          {
            join: 'rolePeopleByRoleName',
            nodes: true,
            fields: [
              {
                join: 'personByPersonId',
                fields: ['fullName']
              }
            ]
          }
        ]
      },
      {
        name: 'topicsList',
        label: 'Description',
        searchable: false,
        searchType: 'modal2'
      },
      {
        name: 'numMembers',
        label: 'Number Members',
        searchType: ['form', 'modal'],
        searchable: false
      },
      [
        {
          name: 'statusList',
          label: 'Moderation Status',
          width: 5,
          type: 'select',
          searchType: ['form', 'modal'],
          options: [
            { value: null, text: 'All' },
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ]
        },
        {
          name: 'active',
          order: 'ACTIVE',
          type: 'select',
          width: 2,
          fieldType: 'Boolean',
          searchType: ['form', 'modal'],
          options: [
            { value: true, text: 'Yes' },
            { value: false, text: 'No' },
            { value: null, text: 'Both' }
          ]
        },
        {
          name: 'listLevel',
          type: 'select',
          options: {
            lookup: 'allEmailListLevels',
            value: 'listLevel',
            text: 'listLevelDesc',
            allowNull: true,
            nullText: 'All',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'EmailListLevelsOrderBy',
                default: 'LIST_LEVEL_DESC_ASC'
              }
            ]
          },
          width: 5
        }
      ],
      {
        name: 'listAliases',
        label: 'Aliases',
        searchable: false,
        showResults: false
      },
      {
        alias: 'groups',
        searchable: false,
        showResults: false,
        join: 'groupEmailsByEmailList',
        nodes: true,
        fields: [
          {
            join: 'groupByGroupId',
            fields: ['groupName']
          }
        ]
      }
    ]
  },
  save: {
    fields: [
      { field: 'nameList', save: false },
      { field: 'emailList', required: true, save: false },
      { field: 'statusList', save: false },
      { field: 'topicsList', save: false },
      { field: 'roleName', save: false },
      { field: 'listAliases', save: false },
      { field: 'active', save: false },
      { field: 'servicenow', save: false },
      { field: 'listLevel', save: false },
      { field: 'inputPatch', type: 'JSON', load: false }
    ],
    key: ['emailList'],
    jsonField: 'inputPatch',
    nodeIdType: 'String',
    input: 'input',
    create: 'createEmailList',
    update: 'updateEmailList'
  },
  load: {
    nodeId: 'emailList',
    key: 'emailListByEmailList'
  },
  form: {
    createHeader: 'Create Email List',
    editHeader: 'Edit Email List - ${nameList}',
    printHeader: 'Email List - ${nameList}',
    schema: [
      [
        {
          name: 'nameList',
          label: 'List Name',
          required: true,
          labelWidth: 3,
          width: 6
        },
        {
          name: 'statusList',
          label: 'Type',
          labelWidth: 2,
          width: 6,
          type: 'select',
          options: [
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ]
        }
      ],
      {
        name: 'topicsList',
        label: 'Description',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        name: 'roleName',
        labelWidth: 2,
        label: 'Owner Role',
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allRoles',
          value: 'roleName',
          text: 'roleName',
          params: [
            {
              field: 'orderBy',
              passArray: true,
              type: 'RolesOrderBy',
              default: 'ROLE_NAME_ASC'
            }
          ]
        },
        required: true
      },
      {
        name: 'ownerName',
        vModel: 'roleName',
        labelWidth: 2,
        readonly: true,
        disabled: true,
        type: 'select',
        options: {
          allowNull: true,
          lookup: 'allRoles',
          value: 'roleName',
          text: 'members'
        }
      },
      {
        name: 'listAliases',
        label: 'Aliases',
        labelWidth: 2
      },
      [
        {
          name: 'active',
          type: 'checkbox',
          width: 6,
          labelWidth: 5,
          default: true
        },
        {
          name: 'listLevel',
          type: 'select',
          default: 'R',
          options: {
            lookup: 'allEmailListLevels',
            value: 'listLevel',
            text: 'listLevelDesc',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'EmailListLevelsOrderBy',
                default: 'LIST_LEVEL_DESC_ASC'
              }
            ]
          },
          width: 6,
          labelWidth: 3
        }
      ]
    ],
    audit: {
      lookup: 'allPersonAudits',
      orderBy: { type: 'PersonAuditsOrderBy', value: 'EVENT_TIME_ASC' },
      dbTableHeaders: [
        {
          value: 'group_email',
          header: 'Group:',
          headerField: 'groupName'
        },
        { value: 'role_people', header: 'Role:', headerField: 'roleName' },
        {
          value: 'subscriber_table',
          header: 'Person:',
          headerField: 'personNameAccount'
        },
        {
          value: 'admin_table',
          header: 'Admin:',
          headerField: 'personNameAccount'
        }
      ]
    }
  },
  joinTables: [
    {
      label: 'Groups',
      triggerRefresh: true,
      addLabel: 'Add Group',
      removeLabel: 'Remove ${groupByGroupId.groupName} from this email list?',
      lookup: 'allGroupEmails',
      join: 'groupByGroupId',
      readonly: { field: 'emailList', value: 'arminfrastructure' },
      fields: [
        {
          field: 'groupId',
          type: 'Int',
          required: true,
          show: false
        },
        'groupName',
        'groupDescription',
        {
          field: 'groupId',
          alias: 'recordId',
          show: false
        }
      ],
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'groups'
        }
      },
      create: 'createGroupEmail',
      delete: 'deleteGroupEmail',
      input: 'groupEmail',
      formType: 'groups',
      multiHeader: 'Added ${groupName} to email list'
    },
    {
      label: 'People',
      export: true,
      exportFilename: 'EmailListMembers',
      addLabel: 'Add Person',
      removeLabel: 'Remove ${fullName} from this email list?',
      lookup: 'allSubscriberPeople',
      readonly: { field: 'emailList', value: 'arminfrastructure' },
      filters: {
        personId: {
          type: 'Boolean',
          isNull: {
            default: false
          }
        }
      },
      fields: [
        { name: 'emailList', show: false, export: true },
        { name: 'topicsList', alias: 'description', show: false, export: true },
        { name: 'roleName', alias: 'ownerRole', show: false, export: true },
        { name: 'listAliases', alias: 'aliases', show: false, export: true },
        {
          name: 'groupNames',
          alias: 'groupsFeedingList',
          show: false,
          export: true
        },
        { name: 'personId', field: 'personId', required: true, type: 'Int' },
        'subscriberEmail',
        { name: 'fullName', label: 'Name' },
        'affiliation',
        { name: 'address1', show: false, export: true },
        { name: 'address2', show: false, export: true },
        { name: 'city', show: false, export: true },
        { name: 'state', show: false, export: true },
        { name: 'countryCode', show: false, export: true },
        { name: 'zipCode', show: false, export: true },
        { name: 'phone', show: false, export: true },
        { name: 'scienceUser', type: 'boolean', show: false, export: true },
        { name: 'statusDesc', alias: 'status', show: false, export: true },
        { field: 'personId', alias: 'recordId', show: false }
      ],
      searchFilters: {
        statusCode: {
          in: {
            type: 'StringArray',
            array: true,
            required: true,
            default:
              '["A", "M", "F"]' /*,
            defaults: {
              field: 'listLevel',
              values: [
                {
                  value: 'I',
                  filter: '["F"]'
                }
              ]
            }*/
          }
        }
      },
      route: {
        name: 'FormEditRecord',
        params: {
          formType: 'people'
        }
      },
      create: 'insertSubscriberPerson',
      delete: 'deleteSubscriberNodeId',
      input: 'subscriberPerson',
      nodeIdType: 'String',
      formType: 'people',
      multiHeader: 'Added ${fullName} to email list'
    },
    {
      label: 'External Emails',
      addLabel: 'Add External Email',
      addType: 'form',
      addForm: [
        { name: 'userSubscriber', label: 'External Email', required: true }
      ],
      removeLabel: 'Remove ${userSubscriber} from this email list?',
      lookup: 'allSubscriberPeople',
      filters: {
        personId: {
          type: 'Boolean',
          isNull: {
            default: true
          }
        }
      },
      fields: [
        { field: 'userSubscriber', name: 'userSubscriber', required: true }
      ],
      create: 'insertSubscriberEmail',
      delete: 'deleteSubscriberNodeId',
      input: 'subscriberEmail',
      nodeIdType: 'String'
    }
  ]
}
